import {
  ModelVersionENV,
  ModelVersionESS,
  ProjectAbstract,
} from '@/domain/project/entities/project.entity';

export type ProjectFestival = ProjectAbstract & {
  venue: Venue;
  location: string;
  avgCapacity: number;
  accessToEnergy: boolean;
  accessToWater: boolean;
  calculateOptions: CalculateOptions;
  models: {
    ess: ModelVersionESS;
    env: ModelVersionENV;
  };
};

export type Venue = (typeof VenueValues)[number];
export const VenueValues = [
  '',
  'ON_PREMISES', // votre bâtiment
  'OFF_PREMISES', // autre bâtiment
  'OUTDOOR', // extérieur
] as const;

export type CalculateOptions = {
  includePublicAnswersForCo2: boolean;
};
